<div class="row">

  <div class="col-sm-6 col-md-4">

    <div class="row no-gutters">
      <div class="col-sm-10 pl-1">
        <mat-form-field class="full-width">
          <mat-label>{{ case.vehicle.damage.trans.area_description | translate }}</mat-label>
          <textarea id="{{idPrefix}}{{case.vehicle.damage.trans.area_description}}"
                    matInput
                    rows="4"
                    class="enabled-disabled-style mb-4"
                    [(ngModel)]="case.vehicle.damage.area_description"
                    [disabled]="true">
          </textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-sm-10">
        <mat-form-field class="full-width">
          <mat-label>{{ case.vehicle.damage.trans.comment | translate }}</mat-label>
          <textarea id="{{idPrefix}}{{case.vehicle.damage.trans.comment}}"
                    matInput
                    rows="7"
                    [(ngModel)]="case.vehicle.damage.comment"
                    (blur)="onChange('vehicle.damage.comment', case.vehicle.damage.comment)">
          </textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="row no-gutters mt-4">
      <div class="col-sm-10 pl-1">
        <span class="iq-color-3">{{ case.vehicle.damage.trans.area_all | translate }}</span>
        <mat-checkbox id="{{idPrefix}}{{case.vehicle.damage.trans.area_all}}"
                      style="float: right;"
                      [checked]="area_all"
                      (change)="area_all = $event.checked">
        </mat-checkbox>
      </div>
    </div>

    <div class="row no-gutters mt-2">
      <div class="col-sm-10 pl-1">
        <span class="iq-color-3">{{ case.vehicle.damage.trans.area_underbody | translate }}</span>
        <mat-checkbox id="{{idPrefix}}{{case.vehicle.damage.trans.area_underbody}}"
                      style="float: right;"
                      [checked]="area_underbody"
                      (change)="area_underbody = $event.checked">
        </mat-checkbox>
      </div>
    </div>

    <div class="row no-gutters mt-2">
      <div class="col-sm-10 pl-1">
        <span class="iq-color-3">{{ case.vehicle.damage.trans.area_interior | translate }}</span>
        <mat-checkbox id="{{idPrefix}}{{case.vehicle.damage.trans.area_interior}}"
                      style="float: right;"
                      [checked]="area_interior"
                      (change)="area_interior = $event.checked">
        </mat-checkbox>
      </div>
    </div>

    <div class="row no-gutters mt-2">
      <div class="col-sm-10 pl-1">
        <span class="iq-color-3">{{ case.vehicle.damage.trans.fire | translate }}</span>
        <mat-checkbox id="{{idPrefix}}{{case.vehicle.damage.trans.fire}}"
                      style="float: right;"
                     [checked]="fire"
                     (change)="fire = $event.checked">
        </mat-checkbox>
      </div>
    </div>

    <div class="row no-gutters mt-2">
      <div class="col-sm-10 pl-1">
        <span class="iq-color-3">{{ case.vehicle.damage.trans.water | translate }}</span>
        <mat-checkbox id="{{idPrefix}}{{case.vehicle.damage.trans.water}}"
                      style="float: right;"
                      [checked]="water"
                      (change)="water = $event.checked">
        </mat-checkbox>
      </div>
    </div>

  </div>


  <div class="col-sm-6 col-md-8">
    <div class="dr-damage-area-selector" *ngIf="das && das.selectedVehicleMeta">

      <div>

        <div class="area-control">

          <div class="row smp-title-thin-border no-gutters">
            <div class="col-sm-8 graphic-key-label">{{ das.selectedVehicleMeta.graphic_key_translated }}</div>
            <div class="col-sm-4">
              <button id="{{idPrefix}}btn.vehicle_menu"
                      mat-icon-button
                      class="float-right"
                      [matMenuTriggerFor]="vehicleMenu">
                <mat-icon>more_horiz</mat-icon>
              </button>
            </div>
          </div>

          <mat-menu #vehicleMenu="matMenu">
            <mat-list>
              <ng-container *ngFor="let group of das.vehicleDamageMetaList">
                <h3 mat-subheader class="vehicle-type-list-header">{{ group.type_translated }}</h3>
                <mat-list-item class="vehicle-type-list"
                               *ngFor="let vehicleMeta of group.meta"
                               id="{{idPrefix}}vehicle_menu.btn.{{vehicleMeta.graphic_key}}"
                               (click)="selectVehicleMeta(vehicleMeta.graphic_key)">
                  <h4 mat-line>{{ vehicleMeta.graphic_key_translated }}</h4>
                </mat-list-item>
                <mat-divider></mat-divider>
              </ng-container>
            </mat-list>
          </mat-menu>

        </div>

        <div class="areas-container">
          <div class="area"
               *ngFor="let area of das.areas"
               [ngStyle]="{'width': area.width, 'height': area.height }">
            <div id="{{idPrefix}}areas.btn.{{area.code}}"
                 [ngClass]="{'selected': area.selected }"
                 (click)="toggleArea(area.code)">
            </div>
          </div>
        </div>

        <div class="image-container">
          <img class="vehicle-type-image" src="{{ das.selectedVehicleMeta.imageLink }}" alt="" />
        </div>

      </div>
    </div>
  </div>

  <div class="col-sm-12 mt-4">
    <mat-form-field class="full-width">
      <mat-label>{{ case.vehicle.damage.trans.damaged_parts | translate }}</mat-label>
      <textarea id="{{idPrefix}}{{case.vehicle.damage.trans.damaged_parts}}"
                matInput
                rows="5"
                [(ngModel)]="case.vehicle.damage.damaged_parts"
                (blur)="onChange('vehicle.damage.damaged_parts', case.vehicle.damage.damaged_parts)">
          </textarea>
    </mat-form-field>
  </div>
</div>
